import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { KnBrInvoiceListDetailItemsComponent } from './kn-br-invoice-list-detail-items.component';

@NgModule({
    imports: [
        NgbModule,
        CommonModule,
        I18nModule,
        MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CarlisleInvoiceDetailsBodyComponent: {
                    component: KnBrInvoiceListDetailItemsComponent,
                },
            },
        } as CmsConfig),
        KnBrInvoiceListDetailItemsComponent,
    ],
})
export class KnBrReturnOrderDetailsItemsModule {}
